import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.workload')
  .filter('workloadShift', workloadShift);

/* @ngInject */
function workloadShift($filter) {
  return function(shifts) {
    let shift;

    shifts.forEach((s) => {
      if (!shift || (s.shiftStartTime < shift.shiftStartTime) || (s.shiftEndTime > shift.shiftEndTime)) {
        shift = s;
      }
    })

    return shift ? $filter('bringozTime')(shift, 'shiftStartTime') : '---';
    // return shift ? $filter('timeWindow')({notBefore: shift.shiftStartTime, notAfter: shift.shiftEndTime}) : '---';
  };
}
